import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import TagCommander from '@axa-asia/hk-tag-commander/lib/TagCommander';
import { goBack, push } from 'react-router-redux';

export class Error extends Component {
  static propTypes = {
    redirect: PropTypes.string,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func
    }),
    goBack: PropTypes.func,
    push: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.redirectBack = this.redirectBack.bind(this);
  }

  redirectBack() {
    if (!this.props.redirect)
      this.props.goBack();
    else
      this.props.push(this.props.redirect);
  }

  render() {
    const { formatMessage } = this.props.intl;

    return <div className="error-page">
      <Helmet title={formatMessage({ id: 'title_error_info' })} />
      <div className="col-md-12">
        <h3 className="small-module-title"><FormattedMessage id="error_title" /></h3>
        <p className="text-longer"><FormattedMessage id="error_description" /></p>
        <button className="button button--ghost" onClick={this.redirectBack}>
          <FormattedMessage id="back" />
        </button>
      </div>
    </div>
  }
}

function mapStateToProps({ error: { redirect } }) {
  return {
    redirect
  }
}

function tagCommanderParams() {
  return {
    id: 'virtualpage',
    data: {
      pagename: 'ecommerce::home::error_generic'
    }
  }
}

export default connect(mapStateToProps, { goBack, push })(injectIntl(TagCommander(Error, tagCommanderParams)));



// WEBPACK FOOTER //
// ./src/app/pages/Error.js